import request from '@/utils/request';

// 查询应用配置（包含大模型配置）
export function getAppConfig() {
  return request({
    url: '/business/appConfig',
    method: 'get'
  });
}

// 更新应用配置（包含大模型配置）
export function updateAppConfig(data) {
  return request({
    url: '/business/appConfig',
    method: 'put',
    data
  });
}

